import {Component, Input} from '@angular/core';
import {FormControl} from "@angular/forms";
import {CfTask} from "@app-web-central/web/shared/data-access/models";

@Component({
  selector: 'as-task-drawer-name',
  templateUrl: './task-drawer-name.component.html',
  styleUrls: ['./task-drawer-name.component.scss'],
})
export class TaskDrawerNameComponent {
  @Input() task!: CfTask;
  @Input() control!: FormControl;
}
